import { MailchimpActionTypes } from './types/actions'
import { initState } from './types/reducer'
import {
  INTEGRATE_MAILCHIMP,
  INTEGRATE_MAILCHIMP_SUCCESS,
  INTEGRATE_MAILCHIMP_ERROR,
} from './constants'

export const initialState: initState = {
  isLoading: false,
  error: {
    message: '',
  },
  data: {
    mailchimp: {
      apiKey: '',
      serverName: '',
      username: '',
    },
  },
}

const reducer = (
  state: initState = initialState,
  action: MailchimpActionTypes,
): initState => {
  switch (action.type) {
    case INTEGRATE_MAILCHIMP:
      return { ...state, isLoading: true }
    case INTEGRATE_MAILCHIMP_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case INTEGRATE_MAILCHIMP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: {
          message: action.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
